import { Component } from '@angular/core';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {RouterLink, RouterLinkActive} from '@angular/router';

@Component({
  selector: 'gr-landing-header',
  templateUrl: './landing-header.component.html',
  imports: [
    RouterLinkActive,
    RouterLink
  ],
  standalone: true
})
export class LandingHeaderComponent {

  protected readonly PAGES_AND_PATHS = PAGES_AND_PATHS;
}
